export default __webpack_public_path__ + "static/img4-7891e800cb8b4e0669201044ea928814.jpg";